import { Flex, Tabs } from '@bynder/design-system';
import {
  IconTextCenter,
  IconTextJustify,
  IconTextLeft,
  IconTextRight,
} from '@bynder/icons';
import { useContext } from 'react';
import { TeaClientContext } from './tea-editor-controls.tsx';

export function AlignmentControl() {
  const { editor } = useContext(TeaClientContext);
  const isLeftAligned = editor?.isActive({ textAlign: 'left' });
  const isRightAligned = editor?.isActive({ textAlign: 'right' });
  const isCenterAligned = editor?.isActive({ textAlign: 'center' });
  const isJustifyAligned = editor?.isActive({ textAlign: 'justify' });

  return (
    <Flex gap="4" direction="column">
      <Tabs variant="clean">
        <Tabs.Tab
          isActive={
            isLeftAligned ||
            (!isCenterAligned && !isRightAligned && !isJustifyAligned)
          }
          icon={<IconTextLeft />}
          label="Align text left"
          isLabelHidden
          onClick={() => {
            editor?.chain().setTextAlign('left').focus().run();
          }}
        />
        <Tabs.Tab
          isActive={isCenterAligned}
          icon={<IconTextCenter />}
          label="Align text center"
          isLabelHidden
          onClick={() => editor?.chain().setTextAlign('center').focus().run()}
        />
        <Tabs.Tab
          isActive={isRightAligned}
          icon={<IconTextRight />}
          label="Align text right"
          isLabelHidden
          onClick={() => editor?.chain().setTextAlign('right').focus().run()}
        />
        <Tabs.Tab
          isActive={isJustifyAligned}
          icon={<IconTextJustify />}
          label="Align text justify"
          isLabelHidden
          onClick={() => editor?.chain().setTextAlign('justify').focus().run()}
        />
      </Tabs>
    </Flex>
  );
}
